import { PAGES } from "src/configs/pages-urls";
import { convertFrameworkRoute } from "src/utils/routes";

export default [
	{
		path: PAGES.experienceDesign.sub.audiences,
		lazy: () =>
			import("src/module--campaigns/pages/audiences.page").then(
				convertFrameworkRoute,
			),
	},
	{
		path: `${PAGES.experienceDesign.sub.audiences}/${PAGES.new}`,
		lazy: () =>
			import("src/module--campaigns/pages/new-audience.page").then(
				convertFrameworkRoute,
			),
	},
	{
		path: `${PAGES.experienceDesign.sub.audiences}/:id`,
		lazy: () =>
			import("src/module--campaigns/pages/edit-audience.page").then(
				convertFrameworkRoute,
			),
	},
	{
		path: PAGES.experienceDesign.sub.campaigns,
		lazy: () =>
			import("src/module--campaigns/pages/campaigns.page").then(
				convertFrameworkRoute,
			),
	},
	{
		path: `${PAGES.experienceDesign.sub.campaigns}/${PAGES.new}`,
		lazy: () =>
			import("src/module--campaigns/pages/new-campaign.page").then(
				convertFrameworkRoute,
			),
	},
	{
		path: `${PAGES.experienceDesign.sub.campaigns}/:id`,
		lazy: () =>
			import("src/module--campaigns/pages/edit-campaign.page").then(
				convertFrameworkRoute,
			),
	},
	{
		path: `${PAGES.experienceDesign.sub.campaigns}/preview/:id`,
		lazy: () =>
			import("src/module--campaigns/pages/preview-campaign.page").then(
				convertFrameworkRoute,
			),
	},
];
